import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { NgIf } from '@angular/common';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { ButtonTriggerEvent } from '../button/button.component';
import { ImageService } from '../../services/image/image.service';

@Component({
  selector: 'ig-tab-image-link-file-selector',
  standalone: true,
  imports: [MatCheckbox, MatTab, MatTabGroup, NgIf, SharedModule, FormsModule],
  templateUrl: './tab.image.link.file.selector.component.html',
  styleUrl: './tab.image.link.file.selector.component.scss',
})
export class TabImageLinkFileSelectorComponent implements OnInit {
  @Input() compressWidth = 1800;
  @Input() useUploadButton = true;
  @Input() initialImg = '';

  form: FormGroup;
  selectedImageData = undefined;
  selectedImageFile = undefined;
  hasCopyrights = false;
  isShowCopyRightsAlert = false;
  imageLink = '';
  imageLinkErrorMsg = '';

  @ViewChild('copyRights', { static: false }) copyRights: ElementRef;

  @Output() onImageUploaded = new EventEmitter<any>();

  constructor(public imgService: ImageService, private _fb: FormBuilder) {
    this.form = this._fb.group({
      imageLink: [null, []],
    });
  }

  ngOnInit() {
    this.initialImg = this.imgService.imageSourceUrl(this.initialImg);
  }

  showCopyRightsAlert() {
    this.copyRights.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center',
    });
    this.isShowCopyRightsAlert = true;
    setTimeout(() => {
      this.isShowCopyRightsAlert = false;
    }, 3000);
  }

  public onImageChange($event) {
    this.imageLink = '';
    this.form.get('imageLink').setValue('');

    const file = $event.srcElement.files[0];
    if (!!file) {
      let reader = new FileReader();

      reader.onload = async (e) => {
        this.selectedImageData = e.target['result'];
        this.selectedImageFile = await this.imgService.compressImageFile(
          file,
          this.compressWidth
        );
        // this.selectedImageSize = await this.imgService.getImageFileSize(file);
        // console.log('size', this.selectedImageSize);
        // this.onImageChanged.emit(imageFile);
      };

      reader.readAsDataURL(file);
    }
  }

  imageLinkChange($event) {
    this.selectedImageFile = null;
    this.selectedImageData = null;
    this.imageLinkErrorMsg = '';
    this.imageLink = this.form.get('imageLink').value;
  }

  reset() {
    this.selectedImageFile = null;
    this.selectedImageData = null;
    this.imageLinkErrorMsg = '';
    this.imageLink = '';
    this.form.get('imageLink').setValue('');
    this.hasCopyrights = false;
  }

  waitingUpload() {
    return this.selectedImageFile || this.imageLink;
  }

  async submit(event?: ButtonTriggerEvent) {
    if (this.selectedImageFile) {
      const base64 = await this.imgService.compressImageFileToBase64(
        this.selectedImageFile,
        this.compressWidth
      );
      this.imgService
        .uploadBase64ImageToAWS(base64, this.compressWidth)
        .subscribe((res) => {
          if (res.success) {
            this.selectedImageFile = null;
            event?.success();
            this.onImageUploaded.emit(res.url);
          } else {
            event?.complete();
          }
        });
      return;
    }

    if (this.imageLink) {
      if (!this.imageLink.startsWith('http')) {
        this.imageLinkErrorMsg = 'Please enter a correct image link.';
        event?.complete();
        return;
      }
      this.imgService
        .uploadBase64ImageToAWS(this.imageLink, this.compressWidth)
        .subscribe((res) => {
          if (res.success) {
            this.imageLink = '';
            event?.success();
            this.onImageUploaded.emit(res.url);
          } else {
            event?.complete();
          }
        });
    }
  }
}
